$( document ).ready(function() {
    $('.dashboard-button').on('click', function() {

        if($(this).hasClass('cms-show')) {
            $(this).removeClass('cms-show');
            $(this).next().slideUp();
        }
        else {
            $('.dashboard-button').removeClass('cms-show');
            $('.dashboard-button').next().slideUp();
            $(this).addClass('cms-show');
            $(this).next().slideDown();
        }
    });
});